<template>
  <lu-vbox lu-flex-wrap lu-vcenter class='vpad-in-20' style='padding: 15px;color: black;'>
        <lu-hbox lu-vcenter >
          <lu-item lu-flex style='width:220px;'>{{ $t('Show numbers per Lots or Mios') }} : </lu-item>
          <el-radio-group
            v-model="lotsMios">
            <el-radio label="lots">{{ $t('Lots') }}</el-radio>
            <el-radio label="mios">{{ $t('Mio') }}</el-radio>
          </el-radio-group>
        </lu-hbox>
  </lu-vbox>
</template>

<script>
import { LuHbox, LuVbox, LuItem } from 'lusis-ui'
import { mapState } from 'vuex';

export default {
  name: 'SettingsLot',
  props: [ 'panel', 'panelId' ],
  components: { LuHbox, LuVbox, LuItem },
  computed: {
    ...mapState({ panelConfig: state => state.settingsMonitor.settingParams.panelConfig }),
    lotsMios: {
      get () {
        let idx = this.panelConfig.findIndex(item => item.id === this.panelId)
        if (idx !== -1) {
          return this.panelConfig[idx].options.lotsMios
        }
        return 'mios'
      },
      set (val) {
        this.panel.options.lotsMios = val
        this.$store.dispatch('settingsMonitor/changeOptionSetting', this.panel)
      }
    }
  }
}
</script>

<style lang='scss'>


</style>